var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('flex-element',{staticClass:"f-break-words f-whitespace-pre-line",attrs:{"element-type":_vm.elementType,"tag":_vm.tag}},[_vm._v(_vm._s(_vm.multiLineText))])}
var staticRenderFns = []

export { render, staticRenderFns }